<h2 mat-dialog-title>E-Mail verfassen</h2>

<mat-dialog-content class="email-dialog-content">
  <mat-progress-bar *ngIf="loading" mode="indeterminate" color="warn"></mat-progress-bar>

  <form [formGroup]="emailForm" class="email-dialog-form" (ngSubmit)="submit()">
    <!-- Empfänger / Kontakte -->
    <div class="row mb-2">
      <div class="col-12">
        <div class="d-flex w-100 gap-2 align-items-stretch">
          <div class="flex-grow-1 email-tags-container">
            <span *ngFor="let email of emailTags; let i = index" class="email-tag">
              {{ email }}
              <button type="button" (click)="removeEmailTag(i)" class="email-tag-remove">&times;</button>
            </span>
            <input
              type="text"
              [(ngModel)]="newEmailInput"
              (keyup.enter)="addEmailTag()"
              (blur)="addEmailTag()"
              (input)="onEmailInput($event)"
              placeholder="Empfänger-E-Mail eingeben"
              class="email-tag-input"
              name="recipientInput"
            >
            <button
              type="button"
              class="btn btn-dark ml-1"
              (click)="openContactPicker()"
              matTooltip="Kontakte auswählen">
              <mat-icon>contact_page</mat-icon>
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary ml-1"
              (click)="openPresetPicker()"
              matTooltip="Preset auswählen">
              <mat-icon class="mr-1">description</mat-icon>
            </button>
          </div>
        </div>
        <div *ngIf="recipientsInvalid && (f['recipients'].dirty || f['recipients'].touched || submitted)" class="text-danger small mt-1">
          <span *ngIf="!getEffectiveRecipientsValue()?.trim()">Bitte mindestens einen Empfänger eingeben.</span>
          <span *ngIf="getEffectiveRecipientsValue()?.trim()">Ungültige E-Mail-Adresse(n).</span>
        </div>
      </div>
    </div>

    <!-- E-Mail-Typ (Versandort: Terminanfrage, Auftrag/Dokumente, …) -->
    <div class="row mb-2">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>E-Mail-Typ</mat-label>
          <mat-select formControlName="mailTypeId" placeholder="Typ wählen">
            <mat-option [value]="null">—</mat-option>
            <mat-option *ngFor="let t of mailTypes" [value]="t.id">{{ t.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Betreff -->
    <div class="row mb-2">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Betreff</mat-label>
          <input matInput formControlName="subject" placeholder="Betreff">
        </mat-form-field>
      </div>
    </div>

    <!-- Prompt + Body -->
    <div class="row mb-2">
      <div class="col-md-4 mb-2">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Prompt für KI-Text</mat-label>
          <textarea matInput [(ngModel)]="promptText" name="promptText" rows="4"
                    placeholder="Kurzbeschreibung eingeben, z. B. 'Absage wegen Krankheit mit neuem Terminvorschlag'"></textarea>
        </mat-form-field>
        <button type="button" mat-stroked-button color="primary" (click)="generateFromPrompt()" [disabled]="generating">
          <mat-icon class="mr-1">auto_fix_high</mat-icon>
          {{ generating ? 'Generiere…' : 'Text generieren' }}
        </button>
      </div>
      <div class="col-md-8 mb-2">
        <label class="d-block mb-1">Text (HTML)</label>
        <div class="simple-editor">
          <div class="editor-toolbar btn-group btn-group-sm mb-1">
            <button type="button" class="btn btn-light" (click)="execCmd('bold')">
              <b>B</b>
            </button>
            <button type="button" class="btn btn-light" (click)="execCmd('italic')">
              <i>I</i>
            </button>
            <button type="button" class="btn btn-light" (click)="execCmd('underline')">
              <u>U</u>
            </button>
            <button type="button" class="btn btn-light" (click)="execCmd('insertUnorderedList')">
              • Liste
            </button>
            <button type="button" class="btn btn-light" (click)="execCmd('insertOrderedList')">
              1. Liste
            </button>
          </div>
          <div
            #bodyEditor
            class="editor-body form-control"
            contenteditable="true"
            [innerHTML]="f['body'].value"
            (input)="onEditorInput()"
            style="min-height: 220px; overflow:auto;"
          ></div>
        </div>
        <div *ngIf="f['body'].invalid && (f['body'].dirty || submitted)" class="text-danger small mt-1">
          Text ist erforderlich.
        </div>
      </div>
    </div>

    <!--div class="row mb-2" *ngIf="presetList?.length">
      <div class="col-12">
        <mat-accordion class="preset-accordion">
          <mat-expansion-panel *ngFor="let cat of presetList">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ cat.name }}</mat-panel-title>
            </mat-expansion-panel-header>
            <table class="table table-sm table-hover mb-0">
              <tbody>
                <tr *ngFor="let item of cat.presets; let i = index" (click)="applyPreset(item)" class="cursor-pointer">
                  <td style="width:32px;">{{ i + 1 }}</td>
                  <td style="width:120px;">{{ item.name }}</td>
                  <td class="text-muted small">{{ item.description }}</td>
                </tr>
              </tbody>
            </table>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div-->

    <!-- Anhänge -->
    <div class="row mb-2" *ngIf="data.attachments?.length">
      <div class="col-12">
        <h6>Anhänge</h6>
        <span class="badge badge-light mr-1" *ngFor="let att of data.attachments">
          {{ att.name }}
        </span>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Abbrechen</button>
  <button mat-raised-button color="primary" type="button" (click)="submit()" [disabled]="loading">
    <mat-icon class="mr-1">send</mat-icon>
    Senden
  </button>
</mat-dialog-actions>

